import { render, staticRenderFns } from "./DdCheckSG.vue?vue&type=template&id=23d426b5&scoped=true&"
import script from "./DdCheckSG.vue?vue&type=script&lang=js&"
export * from "./DdCheckSG.vue?vue&type=script&lang=js&"
import style0 from "./DdCheckSG.vue?vue&type=style&index=0&id=23d426b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d426b5",
  null
  
)

export default component.exports